var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"value":_vm.value,"persistent-hint":"","label":_vm.label,"hint":_vm.hint,"accept":_vm.accept,"disabled":_vm.disabled,"multiple":_vm.multiple,"chips":true,"rules":_vm.rules},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }